<script lang="ts">
	export let table: string
	export let width: number
</script>

<div
	class="table-cont col-span-12 md:col-span-{width} hide-scrollbar flex w-full max-w-4xl justify-start overflow-x-scroll lg:justify-center"
>
	<div class="simple-table w-full min-w-[800px] overflow-hidden rounded-3xl bg-white">
		{@html table}
	</div>
</div>

<style lang="scss">
	:global(.table-cont) {
		:global(.simple-table) {
			:global(*):not(figure, table, tbody, td, tr, th, thead, tfoot) {
				@apply hidden;
			}

			:global(figure) {
			}
			:global(table) {
				@apply align-top;
			}
			:global(tbody) {
			}
			:global(tr) {
				@apply border-none normal-case;

				&:last-child :global(td) {
					@apply pb-8;
				}
			}
			:global(thead) {
				@apply border-none;

				:global(tr) {
					:global(th) {
						@apply px-8 pt-8 align-top;
					}
				}
			}
			:global(th) {
				@apply break-words bg-white text-base font-normal text-neutral-400;

				&:first-child {
					@apply w-[27%];
				}

				&:not(:first-child) {
					@apply border-l border-gray-200;
				}
			}
			:global(td) {
				@apply rounded-none bg-white px-8 py-3 text-base;

				&:first-child {
					@apply font-bold;
				}

				&:not(:first-child) {
					@apply border-l border-gray-200;
				}
			}
		}
	}
</style>
